import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap";
import Loader from "../ContantLoader";
import axios from "axios";
import { Container } from "reactstrap";
import { getToken } from "../../Utils/Common";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import {
  getAllWorkflows,
  getWorkflowsCount,
  putWorkflowData,
  cloneWorkflow,
  getReport,
} from "api/WorkflowApi";
import { useDispatch, useSelector } from "react-redux";
import {
  setBackFromAllWorkflows,
  setWorkflowId,
  setWorkflowLoading,
} from "ReduxStore/Slices/workflowSlice";
import Table from "../Table";
import ContantLoader from "../ContantLoader";
const AllWorkflows = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [showloader, setshowloader] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const { workflowLoading } = useSelector((state) => state.workflowSetter);
  const dispatch = useDispatch();
  const searchText = useRef("");

  useEffect(() => {
    dispatch(setWorkflowLoading(true));
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setWorkflowLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);

    searchText.current.value !== ""
      ? await getWorkflowsCount(searchText.current.value)
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })
      : await getWorkflowsCount()
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })

    searchText.current.value !== ""
      ? await getAllWorkflows(pageSize, startRow, searchText.current.value)
        .then((data) => {
          setDataApi(data);
          dispatch(setWorkflowLoading(false));
        })
      : await getAllWorkflows(pageSize, startRow)
        .then((data) => {
          setDataApi(data);
          dispatch(setWorkflowLoading(false));
        })
  }, []);
  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        // width: 300,
        Header: "Actions",
        accessor: "",
        Cell: ({ cell }) => (

          (
            <div className="workflow_actions">
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Edit Workflow
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "gray", fontSize: "20px" , margin:"10px"}}
                  onClick={(e) => {
                    e.stopPropagation();
                    urlToEditTemplate({
                      id: cell.row.original.id,
                    });
                  }}
                ></i>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Delete Workflow
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-trash"
                  style={{ color: "gray", fontSize: "20px" , margin:"10px"}}
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteWorkflow(e, cell.row.original.id, cell.row.index);
                  }}
                ></i>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Workflow Logs
                  </Tooltip>
                )}
              >
                <i
                  className="fa fa-file-alt"
                  style={{ color: "gray", fontSize: "20px" , margin:"10px"}}
                  onClick={(e) => {
                    e.stopPropagation();
                    workflowLogs({
                      id: cell.row.original.id,
                      name: cell.row.original.name,
                    });
                  }}
                ></i>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    Clone workflow
                  </Tooltip>
                )}
              >
                <i
                  className="fas fa-clone"
                  style={{ color: "gray", fontSize: "20px" , margin:"10px"}}
                  onClick={(e) => {
                    e.stopPropagation();
                    cloneWorkflowApi({
                      id: cell.row.original.id,
                    });
                  }}
                ></i>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{ hide: 50, show: 50 }}
                placement="top"
                key="top"
                overlay={(props) => (
                  <Tooltip id="tooltip-top" {...props}>
                    View Report
                  </Tooltip>
                )}
              >
                <i
                  className="far fa-file-alt"
                  style={{ color: "gray", fontSize: "20px" , margin:"10px"}}
                  onClick={(e) => {
                    e.stopPropagation();
                    viewReport({
                      id: cell.row.original.id,
                    });
                  }}
                ></i>
              </OverlayTrigger>
            </div>
          )
        ),
      },
      {
        // width: 300,
        Header: "Status",
        accessor: "",
        Cell: ({ cell }) => (
          // 
          <div className="custom-control custom-switch d-flex justify-content-center">
            <input
              type="checkbox"
              className="custom-control-input"
              id={"customSwitch1" + cell.row.original.id}
              onChange={(e) => {
                e.stopPropagation();
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                let status = "";
                setPause(cell.row.original.id, cell.row.original.status);
                cell.row.original.status === "active"
                  ? (status = "inactive")
                  : (status = "active");
                let temp = [...dataApi];

                temp[cell.row.index].status = status;
                setDataApi(temp);
              }}
              checked={cell.row.original.status === "active" ? true : false}
            ></input>
            <label
              className="custom-control-label"
              for={"customSwitch1" + cell.row.original.id}
            ></label>
          </div>
        ),
      },
    ],
    [dataApi]
  );
  const tableData = {
    columns,
    data,
  };

  const urlToEditTemplate = (id) => {
    dispatch(setBackFromAllWorkflows(true));
    dispatch(setWorkflowId(id.id));
    props.history.push(`/admin/workflow/createAutomation`);
  };
  const workflowLogs = (id) => {
    sessionStorage.setItem("workflow_id", id.id);
    sessionStorage.setItem("workflow_name", id.name);
    props.history.push("/admin/workflow/workflowLog");
  };
  const setPause = (id, status) => {

    if (status === "active") {
      //put api for inactivating
      editWorkflow(id, "inactive");
    } else {
      //put api for activating
      editWorkflow(id, "active");
    }
  };

  const editWorkflow = (id, statusTobe) => {

    //api for PUT /workflows/:workflowId
    var data = {
      status: statusTobe,
    };
    putWorkflowData(id, data).catch((e) => {

    });
  };

  const deleteWorkflow = async (e, id, idx) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this Workflow?")) {
      const token = "Bearer " + getToken();
      var delConfig = {
        method: "delete",
        url: process.env.REACT_APP_API_BASE_URL + "workflows/" + id,
        headers: { Authorization: token },
      };
      await axios(delConfig)
        .then((res) => {
          let temp = [...dataApi];
          temp.splice(idx, 1);
          setDataApi(temp);

        })
        .catch((err) => {

        });
    } else {

    }
  };

  const cloneWorkflowApi = (id) => {

    cloneWorkflow(id.id)
      .then((data) => {

        urlToEditTemplate({ id: data.workflowId });
      })
  };

  const viewReport = (obj) => {
    let id = obj.id;
    getReport(id)
      .then((data) => {
        props.history.push(`/admin/workflow/report`, data);
      })
  };
  return (
    <Container>
      <div className="page_heading">
        <h2>Workflows List</h2>

        <p className="sm d-flex align-items-center">
          You have {total} workflow.
        </p>
      </div>
      <div></div>
      {
        <div className="dataTableOuter">
          <div className="search_bar_wrap d-flex">
            {/* <label className="search_label mr-3">Search</label> */}
            <input
              className="form-control search-input"
              id="search_input"
              placeholder="Enter Name or Description "
              ref={searchText}
              style={{ maxWidth: "23%", marginLeft: "25px" }}
              onKeyDown={(e) => {
                if (e.keyCode === 13) {
                  dispatch(setWorkflowLoading(true));
                  fetchData({
                    pageSize: 10,
                    pageIndex: 0,
                    searchText: searchText.current.value,
                  })
                    .then(() => {
                      dispatch(setWorkflowLoading(false));
                    })
                }
              }}
            />
            <button
              onClick={() => {
                dispatch(setWorkflowLoading(true));
                fetchData({
                  pageSize: 10,
                  pageIndex: 0,
                  searchText: searchText.current.value,
                })
                  .then(() => {
                    dispatch(setWorkflowLoading(false));
                  })
              }}
              className="lg_btn tertiary search_btn"
              style={{ height: "38px", margin: "0 0 1vh 1vh" }}
            >
              {workflowLoading ? "Loading..." : "Search"}
            </button>
          </div>

          <div className="table-flter rdt_Pagination d-flex align-items-center">
            <span className="inline-label ml-auto">
              Page No. {pageIndex + 1} of {pageCount}
            </span>
          </div>
          {
            <Table
              columns={columns}
              data={data}
              table_type={"AllWorkflows"}
              rowClickFunction={urlToEditTemplate}
              pageCount={pageCount}
              fetchData={fetchData}
              loading={workflowLoading}
            ></Table>
          }
        </div>
      }
    </Container>
  );
};

export default AllWorkflows;
